var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHospitalWithouBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 317,
    viewBox: "0 0 422 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16113_206748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.151 44.5556H159.805C159.776 44.2563 159.76 43.9532 159.76 43.6464C159.76 38.4713 163.912 34.276 169.033 34.276C170.669 34.276 172.205 34.706 173.54 35.458C175.425 30.2122 180.402 26.4648 186.245 26.4648C191.155 26.4648 195.452 29.1122 197.82 33.0714C198.85 32.747 199.946 32.5723 201.082 32.5723C205.476 32.5723 209.266 35.1874 211.012 38.9614C211.613 38.8034 212.244 38.719 212.893 38.719C216.431 38.719 219.392 41.2129 220.151 44.5556Z",
    fill: "#E2E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.053 91.9245H307.632C308.015 90.2393 309.508 88.9823 311.291 88.9823C311.618 88.9823 311.937 89.0246 312.24 89.1043C313.119 87.2018 315.03 85.8835 317.246 85.8835C317.818 85.8835 318.371 85.9716 318.89 86.1352C320.083 84.1392 322.249 82.8047 324.725 82.8047C327.67 82.8047 330.179 84.6936 331.129 87.3382C331.802 86.9591 332.577 86.7424 333.402 86.7424C335.983 86.7424 338.077 88.8574 338.077 91.4662C338.077 91.6208 338.069 91.7735 338.053 91.9245Z",
    fill: "#E2E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.201 73.0125H226.212C226.192 72.8092 226.181 72.6034 226.181 72.395C226.181 68.8798 229.001 66.0302 232.479 66.0302C233.592 66.0302 234.635 66.3223 235.542 66.833C236.823 63.2699 240.202 60.7246 244.17 60.7246C247.506 60.7246 250.425 62.5228 252.032 65.212C252.732 64.9917 253.477 64.873 254.248 64.873C257.233 64.873 259.807 66.6492 260.994 69.2128C261.402 69.1054 261.83 69.048 262.27 69.048C264.675 69.048 266.685 70.742 267.201 73.0125Z",
    fill: "#E2E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.598 86.9421H125.004C125.351 85.4138 126.705 84.2733 128.323 84.2733C128.62 84.2733 128.908 84.312 129.183 84.3841C129.981 82.6583 131.714 81.4625 133.724 81.4625C134.243 81.4625 134.745 81.5426 135.216 81.6908C136.298 79.8804 138.264 78.6699 140.509 78.6699C143.18 78.6699 145.455 80.3832 146.317 82.7821C146.927 82.4384 147.63 82.2416 148.378 82.2416C150.721 82.2416 152.618 84.16 152.618 86.5265C152.618 86.6666 152.612 86.8052 152.598 86.9421Z",
    fill: "#E2E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.203 265.515H407.491V242.836H406.203V265.515Z",
    fill: "#525B6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.186 202.404L400.835 248.18H413.535L407.186 202.404Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.239 245.275L412.633 241.667L412.46 240.426L401.426 243.919L401.239 245.275Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.245 230.815L410.796 228.423L410.623 227.182L403.433 229.458L403.245 230.815Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1675 253.907H57.2701V240.91H56.1675V253.907Z",
    fill: "#525B6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9118 217.736L53.2725 243.973H60.5512L56.9118 217.736Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5039 242.307L60.034 240.24L59.9353 239.527L53.6116 241.531L53.5039 242.307Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6548 234.019L58.9821 232.65L58.8833 231.938L54.7625 233.243L54.6548 234.019Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8799 259.77H45.5422V241.262H43.8799V259.77Z",
    fill: "#525B6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7112 205.359L39.2847 249.405H50.1376L44.7112 205.359Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2529 233.429L48.9906 240.093L48.6931 237.678L41.4934 231.479L41.2529 233.429Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4409 223.775L47.1792 225.402L46.9564 223.594L42.6457 222.113L42.4409 223.775Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.291 256.632H396.385V244.449H395.291V256.632Z",
    fill: "#525B6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.838 220.82L392.267 249.81H399.41L395.838 220.82Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.562 239.295L398.655 243.68L398.46 242.091L393.721 238.01L393.562 239.295Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.346 232.94L397.464 234.011L397.317 232.821L394.48 231.848L394.346 232.94Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.584 260.608C377.673 260.078 377.72 259.534 377.72 258.982C377.72 252.819 371.968 247.822 364.874 247.822C357.78 247.822 352.029 252.819 352.029 258.982C352.029 259.534 352.076 260.078 352.165 260.608H377.584Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.124 257.867C392.212 257.118 392.258 256.353 392.258 255.574C392.258 246.882 386.508 239.836 379.413 239.836C372.319 239.836 366.568 246.882 366.568 255.574C366.568 256.353 366.614 257.118 366.704 257.867H392.124Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.421 267.511C387.331 266.98 387.285 266.437 387.285 265.884C387.285 259.722 393.036 254.725 400.13 254.725C407.224 254.725 412.975 259.722 412.975 265.884C412.975 266.437 412.929 266.98 412.839 267.511H387.421Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.862 267.51C366.749 266.76 366.69 265.995 366.69 265.216C366.69 256.524 373.981 249.479 382.974 249.479C391.968 249.479 399.258 256.524 399.258 265.216C399.258 265.995 399.2 266.76 399.085 267.51H366.862Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.364 249.479C374.869 249.479 370.853 251.713 368.203 255.219C366.854 254.898 365.42 254.724 363.933 254.724C355.954 254.724 349.484 259.721 349.484 265.883C349.484 266.436 349.537 266.979 349.637 267.51H393.66C393.76 266.76 393.813 265.995 393.813 265.216C393.813 256.524 387.343 249.479 379.364 249.479Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6475 260.608C71.5582 260.078 71.5117 259.534 71.5117 258.982C71.5117 252.819 77.2627 247.822 84.357 247.822C91.4511 247.822 97.2021 252.819 97.2021 258.982C97.2021 259.534 97.1556 260.078 97.0664 260.608H71.6475Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.109 257.867C57.0196 257.118 56.9731 256.353 56.9731 255.574C56.9731 246.882 62.7242 239.836 69.8184 239.836C76.9125 239.836 82.6635 246.882 82.6635 255.574C82.6635 256.353 82.617 257.118 82.5279 257.867H57.109Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8138 267.511C61.9031 266.98 61.9496 266.437 61.9496 265.884C61.9496 259.722 56.1986 254.725 49.1044 254.725C42.0103 254.725 36.2593 259.722 36.2593 265.884C36.2593 266.437 36.3058 266.98 36.3951 267.511H61.8138Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.371 267.51C82.4842 266.76 82.5431 265.995 82.5431 265.216C82.5431 256.524 75.2526 249.479 66.2593 249.479C57.2661 249.479 49.9756 256.524 49.9756 265.216C49.9756 265.995 50.0345 266.76 50.1477 267.51H82.371Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8675 249.479C74.3622 249.479 78.3776 251.713 81.0277 255.219C82.3771 254.898 83.811 254.724 85.2972 254.724C93.2773 254.724 99.7464 259.721 99.7464 265.883C99.7464 266.436 99.6941 266.979 99.5937 267.51H55.5711C55.4705 266.76 55.4185 265.995 55.4185 265.216C55.4185 256.524 61.8875 249.479 69.8675 249.479Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.772 95.8973H280.773V89.0254H279.772V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.83 95.8973H272.831V89.0254H271.83V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.886 95.8973H264.887V89.0254H263.886V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.944 95.8973H256.946V89.0254H255.944V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.804 264.498H290.049V149.518H280.804V264.498Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.999 95.8973H249V89.0254H247.999V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.057 95.8973H241.058V89.0254H240.057V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.113 95.8973H233.115V89.0254H232.113V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.168 95.8973H225.169V89.0254H224.168V95.8973Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.141 94.9446H217.091V88.0605H177.141V94.9446Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.489 141.195H345.453V103.482H280.489V141.195Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.147 139.937H285.28V122.721H280.489V122.715H280.775V115.012H280.824V112.221H280.775V105.301H288.147V139.937Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.111 105.301H348.425V101.666H249.111V105.301Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.207 130.406H343.033V110.498H328.207V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.662 130.406H324.49V110.498H309.662V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.501 130.406H306.327V110.498H291.501V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.113 141.195H169.077V103.482H104.113V141.195Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.571 139.937H161.42V105.301H169.077V122.721H164.571V139.937Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.342 267.51H362.45V141.754H280.342V267.51Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.962 143.572H365.602V139.938H248.962V143.572Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.061 169.404H356.622V149.496H325.061V169.404Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.061 192.503H356.622V172.594H325.061V192.503Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.061 215.599H356.622V195.691H325.061V215.599Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.061 238.698H356.622V218.789H325.061V238.698Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.061 261.794H356.622V241.887H325.061V261.794Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 169.404H321.628V149.496H290.066V169.404Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 192.503H321.628V172.594H290.066V192.503Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 215.599H321.628V195.691H290.066V215.599Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 238.698H321.628V218.789H290.066V238.698Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 261.794H321.628V241.887H290.066V261.794Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9688 267.51H169.076V141.754H86.9688V267.51Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9956 267.51H169.076V264.51H85.9956V267.51Z",
    fill: "#ADA19F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.087 267.51H363.168V264.51H280.087V267.51Z",
    fill: "#ADA19F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.077 264.509H161.42V143.57H164.571V148.834H169.077V264.509Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.42 266.833H169.077V264.51H161.42V266.833Z",
    fill: "#AF9893"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8159 143.57H200.455V139.936H83.8159V143.57Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.141 105.301H200.456V101.666H101.141V105.301Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.076 122.715H280.774V96.5996H169.076V122.715Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.076 267.51H280.774V143.957H169.076V267.51Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.705 216.44H274.076V154.391H175.705V216.44Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7949 169.404H124.357V149.496H92.7949V169.404Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7949 192.503H124.357V172.594H92.7949V192.503Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7949 215.599H124.357V195.691H92.7949V215.599Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7949 238.698H124.357V218.789H92.7949V238.698Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7949 261.794H124.357V241.887H92.7949V261.794Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 169.404H159.351V149.496H127.79V169.404Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.532 130.406H121.359V110.498H106.532V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.074 130.406H139.901V110.498H125.074V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.238 130.406H158.066V110.498H143.238V130.406Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 192.503H159.351V172.594H127.79V192.503Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 215.599H159.351V195.691H127.79V215.599Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 238.698H159.351V218.789H127.79V238.698Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 261.794H159.351V241.887H127.79V261.794Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.676 267.8H241.724V236.523H209.676V267.8Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.123 130.723H121.767V129.689H106.123V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.667 130.723H140.312V129.689H124.667V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.83 130.723H158.473V129.689H142.83V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.9 130.723H306.545V129.689H290.9V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.446 130.723H325.09V129.689H309.446V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.607 130.723H343.252V129.689H327.607V130.723Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.794 260.761H89.79L92.794 244.829V260.761ZM111.478 241.887H93.3488L93.95 238.698H112.079L111.478 241.887ZM115.833 218.788H97.7035L98.3049 215.599H116.434L115.833 218.788ZM120.188 195.692H102.058L102.66 192.503H120.789L120.188 195.692ZM124.356 173.584V172.593H106.413L107.015 169.404H124.356V149.496H127.79V155.372L124.356 173.584Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.356 169.404H107.014L110.768 149.496H124.356V169.404Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.789 192.503H102.66L106.414 172.594H124.356V173.584L120.789 192.503Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.434 215.599H98.3047L102.058 195.691H120.188L116.434 215.599Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.08 238.698H93.9507L97.7042 218.789H115.834L112.08 238.698Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.92 260.761H92.7949V244.829L93.3496 241.887H111.479L107.92 260.761Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.79 155.372V149.496H128.897L127.79 155.372Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9688 262.701H92.7947V149.496H86.9688V262.701Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.791 260.761H124.357V243.676L127.791 225.465V238.698H135.39L134.787 241.887H127.791V260.761Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.357 260.76H121.136L124.357 243.676V260.76Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.143 218.788H129.048L129.65 215.599H139.744L139.143 218.788ZM143.497 195.692H133.404L134.005 192.503H144.098L143.497 195.692ZM147.853 172.593H137.758L138.359 169.404H148.454L147.853 172.593Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.455 169.404H138.36L142.115 149.496H152.208L148.455 169.404Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.099 192.503H134.006L137.76 172.594H147.854L144.099 192.503Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.744 215.599H129.651L133.404 195.691H143.497L139.744 215.599Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.389 238.698H127.79V225.465L129.047 218.789H139.142L135.389 238.698Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.228 260.761H127.79V241.887H134.786L131.228 260.761Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.399 169.405H159.741V168.371H127.399V169.405Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4048 192.502H124.747V191.469H92.4048V192.502Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.399 192.502H159.741V191.469H127.399V192.502Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4048 215.6H124.747V214.566H92.4048V215.6Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.399 215.6H159.741V214.566H127.399V215.6Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4048 238.698H124.747V237.664H92.4048V238.698Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.399 238.698H159.741V237.664H127.399V238.698Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.705 217.473H275.843V216.439H175.705V217.473Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4048 261.793H124.747V260.76H92.4048V261.793Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.399 261.793H159.741V260.76H127.399V261.793Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4048 169.405H124.747V168.371H92.4048V169.405Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.357 262.7H127.791V149.367H124.357V262.7Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6274 241.886H159.741V238.697H91.6274V241.886Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6274 218.789H159.741V215.6H91.6274V218.789Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6274 195.693H159.741V192.504H91.6274V195.693Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6274 172.593H159.741V169.404H91.6274V172.593Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.066 260.761H290.049V216.506L290.219 215.599H308.349L307.748 218.788H290.066V238.698H303.995L303.393 241.887H290.066V260.761ZM312.102 195.692H293.974L294.575 192.503H312.705L312.102 195.692ZM316.458 172.593H298.328L298.929 169.404H317.059L316.458 172.593Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.059 169.404H298.929L302.682 149.496H320.812L317.059 169.404Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.703 192.503H294.574L298.327 172.594H316.457L312.703 192.503Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.348 215.599H290.218L293.973 195.691H312.101L308.348 215.599Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.994 238.698H290.066V218.789H307.747L303.994 238.698Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.835 260.761H290.066V241.887H303.393L299.835 260.761Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.06 260.761H321.626V243.715L325.06 225.505V238.698H332.667L332.066 241.887H325.06V260.761ZM336.42 218.788H326.327L326.928 215.599H337.021L336.42 218.788ZM340.774 195.692H330.681L331.282 192.503H341.377L340.774 195.692ZM345.13 172.593H335.036L335.638 169.404H345.731L345.13 172.593Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.732 169.404H335.639L339.392 149.496H349.486L345.732 169.404Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.378 192.503H331.284L335.037 172.594H345.132L341.378 192.503Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.021 215.599H326.928L330.681 195.691H340.775L337.021 215.599Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.667 238.698H325.061V225.506L326.328 218.789H336.421L332.667 238.698Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.508 260.761H325.061V241.887H332.066L328.508 260.761Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.628 260.761H318.414L321.628 243.715V260.761Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.635 262.7H325.068V149.367H321.635V262.7Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.907 241.886H357.02V238.697H288.907V241.886Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.907 218.789H357.02V215.6H288.907V218.789Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.907 195.693H357.02V192.504H288.907V195.693Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.907 172.593H357.02V169.404H288.907V172.593Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.541 129.688H108.869L114.309 110.498H118.982L113.541 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.835 129.688H129.563L135.004 110.498H138.275L132.835 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.718 129.688H144.114L149.555 110.498H152.158L146.718 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.953 129.688H293.281L298.721 110.498H303.394L297.953 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.244 129.688H313.973L319.413 110.498H322.684L317.244 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.129 129.688H328.525L333.965 110.498H336.569L331.129 129.688Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.613 169.405H356.954V168.371H324.613V169.405Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.617 192.502H321.959V191.469H289.617V192.502Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.613 192.502H356.954V191.469H324.613V192.502Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.617 215.6H321.959V214.566H289.617V215.6Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.613 215.6H356.954V214.566H324.613V215.6Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.617 238.698H321.959V237.664H289.617V238.698Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.613 238.698H356.954V237.664H324.613V238.698Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.617 261.793H321.959V260.76H289.617V261.793Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.613 261.793H356.954V260.76H324.613V261.793Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.617 169.405H321.959V168.371H289.617V169.405Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.076 105.301H280.774V96.5996H169.076V105.301Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.607 98.578H283.245V94.9434H166.607V98.578Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.14 88.0604H218.093V84.4258H176.14V88.0604Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.48 236.524H276.368V227.529H173.48V236.524Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.571 267.8H225.828V236.523H225.571V267.8Z",
    fill: "#ADA19F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.287 267.51H274.077V236.523H268.287V267.51Z",
    fill: "#ADA19F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.705 267.51H181.494V236.523H175.705V267.51Z",
    fill: "#ADA19F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.026 260.762H223.5V238.182H212.026V260.762Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.898 260.762H239.371V238.182H227.898V260.762Z",
    fill: "#A8B9D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.059 260.762H213.053L217.007 238.182H222.013L218.059 260.762Z",
    fill: "#C4C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.16 260.762H229.153L233.109 238.182H238.115L234.16 260.762Z",
    fill: "#C4C8CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.798 216.44H182.096L197.566 154.391H211.269L195.798 216.44Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.39 216.44H230.344L245.815 154.391H271.86L256.39 216.44Z",
    fill: "#D3DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.615 219.607H200.457V153.688H199.615V219.607Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.583 219.607H250.426V153.688H249.583V219.607Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.258 219.607H225.1V153.688H224.258V219.607Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.512 187.1H276.72V186.195H174.512V187.1Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.715 263.58H290.049V209.07H281.715V263.58Z",
    fill: "#F6F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.092 90.031H280.775V89.0254H217.092V90.031Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4659 243.936C78.9245 239.899 77.4146 235.861 76.3187 231.662C72.9465 218.739 73.7607 209.319 73.8865 204.791C73.903 204.193 72.9493 204.029 72.866 204.647C72.5794 206.771 72.5157 208.931 72.5017 211.076C72.4779 214.7 72.6967 218.327 73.1584 221.947C70.6849 222.596 68.3447 221.624 66.4305 219.88C63.1306 216.874 61.9527 212.867 61.434 208.427C61.3808 207.974 61.3645 207.544 60.9976 207.282C60.9159 207.049 60.5781 206.978 60.4944 207.325C59.9713 207.867 60.2247 208.953 60.3052 209.651C61.3941 219.106 67.104 223.688 71.7011 223.648C72.2053 223.645 72.8183 223.618 73.3662 223.466C73.6976 225.727 74.1237 227.973 74.6448 230.195C75.6381 234.429 77.0314 238.515 78.5645 242.564C83.8067 256.405 85.4794 263.477 86.9688 267.484C87.1939 268.288 88.3775 267.951 88.1705 267.136C88.0966 266.846 84.0066 253.208 80.4659 243.936Z",
    fill: "#1B2528"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.468 207.545C101.419 207.247 101.246 207.05 101.18 206.77C101.093 206.402 100.497 206.365 100.434 206.77C100.399 207.001 100.271 207.144 100.221 207.382C100.062 208.147 100.448 212.453 99.439 219.044C99.1709 220.796 98.8749 222.539 98.2951 224.21C97.3583 226.914 95.651 229.827 93.5281 231.669C93.4607 227.808 93.2312 223.951 92.7712 220.116C92.4959 217.82 92.1485 215.537 91.7267 213.265C91.5212 212.16 91.2988 211.057 91.0599 209.959C90.8092 208.806 90.5729 207.7 90.0247 206.655C89.8562 206.336 89.3775 206.485 89.3768 206.84C89.3746 207.863 89.578 208.806 89.79 209.801C90.0012 210.79 90.1988 211.783 90.3828 212.779C91.7469 220.16 92.2599 226.715 92.2542 234.105C90.0054 231.257 88.0389 227.846 86.582 224.497C84.8308 220.47 83.6512 216.137 83.1602 211.741C83.023 210.51 82.9394 209.273 82.9133 208.037C82.8997 207.396 82.8867 206.755 82.8739 206.114C82.8674 205.783 82.7418 204.789 82.1898 205.08C81.6821 205.349 81.7301 205.946 81.6876 206.469C81.6413 207.039 81.6373 207.607 81.6444 208.178C81.658 209.273 81.7162 210.368 81.817 211.457C82.5469 219.353 85.507 227.157 90.0078 233.553C90.6939 234.527 91.4023 235.573 92.2355 236.424C92.0438 249.062 90.1787 265.027 90.1461 266.302C90.139 266.583 90.2021 266.872 90.2435 267.15C90.3286 267.724 91.0771 267.59 91.2301 267.15C91.5195 266.318 91.4896 265.993 91.9209 261.383C92.6901 253.161 93.5517 234.327 93.5485 233.564C96.2207 231.63 98.1129 228.658 99.3494 225.553C100.005 223.905 100.391 222.21 100.679 220.455C101.662 214.486 101.631 208.521 101.468 207.545Z",
    fill: "#1B2528"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1003 197.231C83.2016 196.32 83.2543 195.389 83.2543 194.441C83.2543 183.873 76.7295 175.305 68.6806 175.305C60.6318 175.305 54.1069 183.873 54.1069 194.441C54.1069 195.389 54.1598 196.32 54.261 197.231H83.1003Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5925 192.527C99.6938 191.243 99.7465 189.929 99.7465 188.593C99.7465 173.688 93.2217 161.605 85.1728 161.605C77.1241 161.605 70.5991 173.688 70.5991 188.593C70.5991 189.929 70.652 191.243 70.7533 192.527H99.5925Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9331 209.064C70.8047 207.78 70.7378 206.466 70.7378 205.13C70.7378 190.226 79.0093 178.143 89.2128 178.143C99.4164 178.143 107.688 190.226 107.688 205.13C107.688 206.466 107.621 207.78 107.493 209.064H70.9331Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1182 178.143C80.0186 178.143 75.463 181.976 72.4564 187.988C70.9252 187.435 69.2985 187.139 67.6122 187.139C58.5584 187.139 51.2188 195.707 51.2188 206.275C51.2188 207.222 51.2781 208.155 51.392 209.064H101.338C101.453 207.781 101.512 206.466 101.512 205.13C101.512 190.226 94.1722 178.143 85.1182 178.143Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.842 208.578C392.786 208.207 392.236 207.919 392.001 208.248C391.767 208.577 391.751 208.355 391.567 209.064C391.04 211.103 390.146 213.074 389.038 214.798C386.918 218.1 384.631 219.766 382.007 221.415C382.868 218.825 383.324 216.058 383.1 213.268C383.018 212.251 382.876 211.196 382.329 210.263C382.176 210.003 381.712 210.056 381.698 210.347C381.629 211.786 382.101 212.872 381.93 215.45C381.522 221.598 377.84 228.121 374.087 232.688C374.012 224.955 373.393 216.168 371.021 208.37C370.632 207.09 370.108 205.873 369.607 204.624C369.49 204.331 369.083 204.457 369.168 204.748C369.29 205.164 370.611 210.53 370.696 210.901C372.064 216.84 372.69 223.42 372.857 229.42C369.02 224.96 366.192 219.744 364.522 214.295C364.029 212.686 363.754 211.024 363.141 209.443C363.056 209.225 362.689 209.202 362.672 209.443C362.504 211.811 363.876 215.999 364.785 218.274C366.628 222.887 369.199 227.021 372.489 230.714C372.617 230.857 372.09 266.945 372.269 267.402C372.572 268.172 373.989 268.714 374.04 267.346C374.062 266.789 374.107 244.847 374.096 234.682C374.508 234.442 374.743 234.012 375.731 232.749C378.018 229.82 380.192 226.18 381.528 222.744C382.564 222.686 389.662 219.056 392.436 210.794C392.514 210.557 392.87 209.438 392.91 209.188C392.944 208.974 392.873 208.789 392.842 208.578Z",
    fill: "#1B2528"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.215 196.784C368.3 195.658 368.345 194.508 368.345 193.338C368.345 180.285 362.828 169.703 356.025 169.703C349.22 169.703 343.704 180.285 343.704 193.338C343.704 194.508 343.748 195.658 343.833 196.784H368.215Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.159 190.974C382.244 189.388 382.289 187.764 382.289 186.115C382.289 167.706 376.773 152.783 369.968 152.783C363.164 152.783 357.648 167.706 357.648 186.115C357.648 187.764 357.693 189.388 357.778 190.974H382.159Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.647 211.399C377.562 210.274 377.517 209.124 377.517 207.954C377.517 194.901 383.033 184.318 389.837 184.318C396.642 184.318 402.158 194.901 402.158 207.954C402.158 209.124 402.113 210.274 402.028 211.399H377.647Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.928 211.399C357.82 209.813 357.763 208.19 357.763 206.54C357.763 188.132 364.757 173.209 373.382 173.209C382.009 173.209 389.001 188.132 389.001 206.54C389.001 208.19 388.945 209.813 388.837 211.399H357.928Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.92 173.209C365.609 173.209 361.758 177.944 359.216 185.368C357.921 184.687 356.546 184.319 355.12 184.319C347.467 184.319 341.261 194.901 341.261 207.954C341.261 209.124 341.312 210.274 341.408 211.399H383.633C383.729 209.813 383.779 208.19 383.779 206.54C383.779 188.132 377.575 173.209 369.92 173.209Z",
    fill: "#C6D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1685 268.187H416.824V266.834H30.1685V268.187Z",
    fill: "#9FC0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.455 264.509H280.797V148.834H285.28V143.57H288.455V209.07H281.715V260.698L281.704 260.76H281.715V263.58H288.455V264.509Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.28 143.57H288.455V143.555H285.28V143.57Z",
    fill: "#2C373A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.797 266.833H288.455V264.51H280.797V266.833Z",
    fill: "#AF9893"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.716 260.76H281.705L281.716 260.699V260.76Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.715 263.58H288.455V209.07H281.715V263.58Z",
    fill: "#ECE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.797 266.848H288.455V266.834H280.797V266.848Z",
    fill: "#2C373A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.57 148.836H285.28V122.721H164.57V148.836Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.57 148.835H285.28V137.799H164.57V148.835Z",
    fill: "#977672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.152 111.057H183.403V108.266H176.152V111.057Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.433 115.31H177.685V112.52H170.433V115.31Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.956 119.498H182.378V117.137H174.956V119.498Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.78 115.117H186.99V112.756H179.78V115.117Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.32 119.483H231.184V117.373H225.32V119.483Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.202 116.043H235.066V113.934H229.202V116.043Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.187 246.041H201.051V243.932H195.187V246.041Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.07 242.605H204.933V240.494H199.07V242.605Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.68 245.011H263.544V242.9H257.68V245.011Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.591 248.849H266.455V246.74H260.591V248.849Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.964 112.031H264.216V109.24H256.964V112.031Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.405 119.482H280.766V116.691H278.405V119.482Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.774 115.012H280.823V112.221H280.774V115.012Z",
    fill: "#DBD8D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.78 115.012H280.774V112.221H275.78V115.012Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.561 115.699H267.813V112.908H260.561V115.699Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.306 135.588C235.306 141.511 230.525 146.313 224.628 146.313C218.73 146.313 213.949 141.511 213.949 135.588C213.949 129.665 218.73 124.863 224.628 124.863C230.525 124.863 235.306 129.665 235.306 135.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.781 135.589C233.781 140.666 229.683 144.782 224.629 144.782C219.573 144.782 215.475 140.666 215.475 135.589C215.475 130.512 219.573 126.396 224.629 126.396C229.683 126.396 233.781 130.512 233.781 135.589Z",
    fill: "#A18985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.609 129.478L223.773 129.459L223.719 134.668L218.526 134.681L218.53 136.523L223.7 136.511L223.647 141.697L225.483 141.716L225.537 136.507L230.73 136.494L230.725 134.652L225.555 134.665L225.609 129.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.811 116.629H214.064V113.838H206.811V116.629Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.474 112.443H209.727V109.652H202.474V112.443Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.993 119.498H265.415V117.137H257.993V119.498Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.779 255.556H253.031V252.766H245.779V255.556Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.374 259.224H256.626V256.434H249.374V259.224Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.806 263.023H254.228V260.662H246.806V263.023Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.82 256.13H198.071V253.338H190.82V256.13Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.223 259.796H194.475V257.006H187.223V259.796Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.622 263.598H197.045V261.236H189.622V263.598Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.007 115.748H259.217V113.387H252.007V115.748Z",
    fill: "#E8E2D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.971 264.62H294.444V257.543H293.971V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.304 264.62H317.777V257.543H317.304V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.042 256.564H292.706C292.507 256.564 292.346 256.726 292.346 256.926V257.61C292.346 257.811 292.507 257.972 292.706 257.972H319.042C319.242 257.972 319.402 257.811 319.402 257.61V256.926C319.402 256.726 319.242 256.564 319.042 256.564Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.042 258.562H292.706C292.507 258.562 292.346 258.724 292.346 258.923V259.608C292.346 259.807 292.507 259.969 292.706 259.969H319.042C319.242 259.969 319.402 259.807 319.402 259.608V258.923C319.402 258.724 319.242 258.562 319.042 258.562Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.042 260.561H292.706C292.507 260.561 292.346 260.722 292.346 260.922V261.607C292.346 261.807 292.507 261.968 292.706 261.968H319.042C319.242 261.968 319.402 261.807 319.402 261.607V260.922C319.402 260.722 319.242 260.561 319.042 260.561Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.534 265.163H292.215V264.959C292.215 264.472 292.609 264.076 293.096 264.076H318.653C319.14 264.076 319.534 264.472 319.534 264.959V265.163Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.575 265.02H292.12C292.01 265.02 291.92 265.11 291.92 265.22V265.311C291.92 265.423 292.01 265.511 292.12 265.511H319.575C319.684 265.511 319.774 265.423 319.774 265.311V265.22C319.774 265.11 319.684 265.02 319.575 265.02Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.041 272.494H293.568V265.512H293.041V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.405 272.494H318.932V265.512H318.405V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.388 264.62H329.861V257.543H329.388V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.719 264.62H353.192V257.543H352.719V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.459 256.564H328.121C327.923 256.564 327.763 256.726 327.763 256.926V257.61C327.763 257.811 327.923 257.972 328.121 257.972H354.459C354.657 257.972 354.817 257.811 354.817 257.61V256.926C354.817 256.726 354.657 256.564 354.459 256.564Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.459 258.562H328.121C327.923 258.562 327.763 258.724 327.763 258.923V259.608C327.763 259.807 327.923 259.969 328.121 259.969H354.459C354.657 259.969 354.817 259.807 354.817 259.608V258.923C354.817 258.724 354.657 258.562 354.459 258.562Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.459 260.561H328.121C327.923 260.561 327.763 260.722 327.763 260.922V261.607C327.763 261.807 327.923 261.968 328.121 261.968H354.459C354.657 261.968 354.817 261.807 354.817 261.607V260.922C354.817 260.722 354.657 260.561 354.459 260.561Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.949 265.163H327.63V264.959C327.63 264.472 328.024 264.076 328.511 264.076H354.07C354.555 264.076 354.949 264.472 354.949 264.959V265.163Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.99 265.02H327.536C327.425 265.02 327.335 265.11 327.335 265.22V265.311C327.335 265.423 327.425 265.511 327.536 265.511H354.99C355.099 265.511 355.189 265.423 355.189 265.311V265.22C355.189 265.11 355.099 265.02 354.99 265.02Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.459 272.494H328.986V265.512H328.459V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.82 272.494H354.347V265.512H353.82V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.812 264.62H133.285V257.543H132.812V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.146 264.62H156.618V257.543H156.146V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.883 256.564H131.546C131.348 256.564 131.187 256.726 131.187 256.926V257.61C131.187 257.811 131.348 257.972 131.546 257.972H157.883C158.081 257.972 158.242 257.811 158.242 257.61V256.926C158.242 256.726 158.081 256.564 157.883 256.564Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.883 258.562H131.546C131.348 258.562 131.187 258.724 131.187 258.923V259.608C131.187 259.807 131.348 259.969 131.546 259.969H157.883C158.081 259.969 158.242 259.807 158.242 259.608V258.923C158.242 258.724 158.081 258.562 157.883 258.562Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.883 260.561H131.546C131.348 260.561 131.187 260.722 131.187 260.922V261.607C131.187 261.807 131.348 261.968 131.546 261.968H157.883C158.081 261.968 158.242 261.807 158.242 261.607V260.922C158.242 260.722 158.081 260.561 157.883 260.561Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.375 265.163H131.056V264.959C131.056 264.472 131.45 264.076 131.935 264.076H157.494C157.981 264.076 158.375 264.472 158.375 264.959V265.163Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.415 265.02H130.961C130.851 265.02 130.761 265.11 130.761 265.22V265.311C130.761 265.423 130.851 265.511 130.961 265.511H158.415C158.525 265.511 158.615 265.423 158.615 265.311V265.22C158.615 265.11 158.525 265.02 158.415 265.02Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.882 272.494H132.409V265.512H131.882V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.244 272.494H157.771V265.512H157.244V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.333 264.62H95.8058V257.543H95.333V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.665 264.62H119.138V257.543H118.665V264.62Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.406 256.564H94.0691C93.8708 256.564 93.71 256.726 93.71 256.926V257.61C93.71 257.811 93.8708 257.972 94.0691 257.972H120.406C120.604 257.972 120.765 257.811 120.765 257.61V256.926C120.765 256.726 120.604 256.564 120.406 256.564Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.406 258.562H94.0691C93.8708 258.562 93.71 258.724 93.71 258.923V259.608C93.71 259.807 93.8708 259.969 94.0691 259.969H120.406C120.604 259.969 120.765 259.807 120.765 259.608V258.923C120.765 258.724 120.604 258.562 120.406 258.562Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.406 260.561H94.0691C93.8708 260.561 93.71 260.722 93.71 260.922V261.607C93.71 261.807 93.8708 261.968 94.0691 261.968H120.406C120.604 261.968 120.765 261.807 120.765 261.607V260.922C120.765 260.722 120.604 260.561 120.406 260.561Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.896 265.163H93.5771V264.959C93.5771 264.472 93.9712 264.076 94.4573 264.076H120.016C120.502 264.076 120.896 264.472 120.896 264.959V265.163Z",
    fill: "#C7BEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.936 265.02H93.4822C93.372 265.02 93.2827 265.11 93.2827 265.22V265.311C93.2827 265.423 93.372 265.511 93.4822 265.511H120.936C121.047 265.511 121.136 265.423 121.136 265.311V265.22C121.136 265.11 121.047 265.02 120.936 265.02Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4033 272.494H94.9304V265.512H94.4033V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.767 272.494H120.294V265.512H119.767V272.494Z",
    fill: "#384F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.838 256.841L69.0443 256.719C69.0443 256.719 68.9558 255.078 68.9558 254.296C68.9558 253.346 68.6728 251.947 68.7835 251.973C69.0937 252.048 69.6295 252.339 69.8782 252.695C70.7392 253.921 70.838 256.841 70.838 256.841Z",
    fill: "#B3C1BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.326 255.055C340.329 255.039 340.331 255.025 340.334 255.011C340.331 255.025 340.329 255.039 340.328 255.055C340.328 255.055 340.328 255.055 340.326 255.055ZM340.359 254.366C340.359 254.363 340.359 254.361 340.359 254.358C340.356 254.346 340.356 254.335 340.356 254.322C340.356 254.335 340.356 254.346 340.359 254.358C340.359 254.361 340.359 254.363 340.359 254.366Z",
    fill: "#8381A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.434 254.702C264.41 254.592 264.389 254.482 264.367 254.375C264.389 254.482 264.41 254.592 264.434 254.702Z",
    fill: "#796163"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16113_206748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 317,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalWithouBg);
export default __webpack_public_path__ + "static/media/HospitalWithouBG.f9adab4abe0ccca5376c272961272103.svg";
export { ForwardRef as ReactComponent };